"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MissingRequiredParameter = exports.InvalidExecutionInput = exports.ExecutionAlreadyExists = exports.InvalidOutput = exports.TaskTimedOut = exports.TaskDoesNotExist = exports.ExecutionNotRedrivable = exports.ExecutionLimitExceeded = exports.InvalidToken = exports.StateMachineDoesNotExist = exports.KmsInvalidStateException = exports.ExecutionDoesNotExist = exports.ServiceQuotaExceededException = exports.ResourceNotFound = exports.ValidationException = exports.StateMachineTypeNotSupported = exports.StateMachineLimitExceeded = exports.StateMachineDeleting = exports.StateMachineAlreadyExists = exports.InvalidTracingConfiguration = exports.InvalidLoggingConfiguration = exports.InvalidDefinition = exports.InvalidArn = exports.ConflictException = exports.TooManyTags = exports.KmsThrottlingException = exports.KmsAccessDeniedException = exports.InvalidName = exports.InvalidEncryptionConfiguration = exports.ActivityWorkerLimitExceeded = exports.ActivityLimitExceeded = exports.ActivityDoesNotExist = exports.ActivityAlreadyExists = void 0;
const SFNServiceException_1 = require("./SFNServiceException");
class ActivityAlreadyExists extends SFNServiceException_1.SFNServiceException {
    name = "ActivityAlreadyExists";
    $fault = "client";
    constructor(opts) {
        super({
            name: "ActivityAlreadyExists",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, ActivityAlreadyExists.prototype);
    }
}
exports.ActivityAlreadyExists = ActivityAlreadyExists;
class ActivityDoesNotExist extends SFNServiceException_1.SFNServiceException {
    name = "ActivityDoesNotExist";
    $fault = "client";
    constructor(opts) {
        super({
            name: "ActivityDoesNotExist",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, ActivityDoesNotExist.prototype);
    }
}
exports.ActivityDoesNotExist = ActivityDoesNotExist;
class ActivityLimitExceeded extends SFNServiceException_1.SFNServiceException {
    name = "ActivityLimitExceeded";
    $fault = "client";
    constructor(opts) {
        super({
            name: "ActivityLimitExceeded",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, ActivityLimitExceeded.prototype);
    }
}
exports.ActivityLimitExceeded = ActivityLimitExceeded;
class ActivityWorkerLimitExceeded extends SFNServiceException_1.SFNServiceException {
    name = "ActivityWorkerLimitExceeded";
    $fault = "client";
    constructor(opts) {
        super({
            name: "ActivityWorkerLimitExceeded",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, ActivityWorkerLimitExceeded.prototype);
    }
}
exports.ActivityWorkerLimitExceeded = ActivityWorkerLimitExceeded;
class InvalidEncryptionConfiguration extends SFNServiceException_1.SFNServiceException {
    name = "InvalidEncryptionConfiguration";
    $fault = "client";
    constructor(opts) {
        super({
            name: "InvalidEncryptionConfiguration",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, InvalidEncryptionConfiguration.prototype);
    }
}
exports.InvalidEncryptionConfiguration = InvalidEncryptionConfiguration;
class InvalidName extends SFNServiceException_1.SFNServiceException {
    name = "InvalidName";
    $fault = "client";
    constructor(opts) {
        super({
            name: "InvalidName",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, InvalidName.prototype);
    }
}
exports.InvalidName = InvalidName;
class KmsAccessDeniedException extends SFNServiceException_1.SFNServiceException {
    name = "KmsAccessDeniedException";
    $fault = "client";
    constructor(opts) {
        super({
            name: "KmsAccessDeniedException",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, KmsAccessDeniedException.prototype);
    }
}
exports.KmsAccessDeniedException = KmsAccessDeniedException;
class KmsThrottlingException extends SFNServiceException_1.SFNServiceException {
    name = "KmsThrottlingException";
    $fault = "client";
    constructor(opts) {
        super({
            name: "KmsThrottlingException",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, KmsThrottlingException.prototype);
    }
}
exports.KmsThrottlingException = KmsThrottlingException;
class TooManyTags extends SFNServiceException_1.SFNServiceException {
    name = "TooManyTags";
    $fault = "client";
    resourceName;
    constructor(opts) {
        super({
            name: "TooManyTags",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, TooManyTags.prototype);
        this.resourceName = opts.resourceName;
    }
}
exports.TooManyTags = TooManyTags;
class ConflictException extends SFNServiceException_1.SFNServiceException {
    name = "ConflictException";
    $fault = "client";
    constructor(opts) {
        super({
            name: "ConflictException",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, ConflictException.prototype);
    }
}
exports.ConflictException = ConflictException;
class InvalidArn extends SFNServiceException_1.SFNServiceException {
    name = "InvalidArn";
    $fault = "client";
    constructor(opts) {
        super({
            name: "InvalidArn",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, InvalidArn.prototype);
    }
}
exports.InvalidArn = InvalidArn;
class InvalidDefinition extends SFNServiceException_1.SFNServiceException {
    name = "InvalidDefinition";
    $fault = "client";
    constructor(opts) {
        super({
            name: "InvalidDefinition",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, InvalidDefinition.prototype);
    }
}
exports.InvalidDefinition = InvalidDefinition;
class InvalidLoggingConfiguration extends SFNServiceException_1.SFNServiceException {
    name = "InvalidLoggingConfiguration";
    $fault = "client";
    constructor(opts) {
        super({
            name: "InvalidLoggingConfiguration",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, InvalidLoggingConfiguration.prototype);
    }
}
exports.InvalidLoggingConfiguration = InvalidLoggingConfiguration;
class InvalidTracingConfiguration extends SFNServiceException_1.SFNServiceException {
    name = "InvalidTracingConfiguration";
    $fault = "client";
    constructor(opts) {
        super({
            name: "InvalidTracingConfiguration",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, InvalidTracingConfiguration.prototype);
    }
}
exports.InvalidTracingConfiguration = InvalidTracingConfiguration;
class StateMachineAlreadyExists extends SFNServiceException_1.SFNServiceException {
    name = "StateMachineAlreadyExists";
    $fault = "client";
    constructor(opts) {
        super({
            name: "StateMachineAlreadyExists",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, StateMachineAlreadyExists.prototype);
    }
}
exports.StateMachineAlreadyExists = StateMachineAlreadyExists;
class StateMachineDeleting extends SFNServiceException_1.SFNServiceException {
    name = "StateMachineDeleting";
    $fault = "client";
    constructor(opts) {
        super({
            name: "StateMachineDeleting",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, StateMachineDeleting.prototype);
    }
}
exports.StateMachineDeleting = StateMachineDeleting;
class StateMachineLimitExceeded extends SFNServiceException_1.SFNServiceException {
    name = "StateMachineLimitExceeded";
    $fault = "client";
    constructor(opts) {
        super({
            name: "StateMachineLimitExceeded",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, StateMachineLimitExceeded.prototype);
    }
}
exports.StateMachineLimitExceeded = StateMachineLimitExceeded;
class StateMachineTypeNotSupported extends SFNServiceException_1.SFNServiceException {
    name = "StateMachineTypeNotSupported";
    $fault = "client";
    constructor(opts) {
        super({
            name: "StateMachineTypeNotSupported",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, StateMachineTypeNotSupported.prototype);
    }
}
exports.StateMachineTypeNotSupported = StateMachineTypeNotSupported;
class ValidationException extends SFNServiceException_1.SFNServiceException {
    name = "ValidationException";
    $fault = "client";
    reason;
    constructor(opts) {
        super({
            name: "ValidationException",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, ValidationException.prototype);
        this.reason = opts.reason;
    }
}
exports.ValidationException = ValidationException;
class ResourceNotFound extends SFNServiceException_1.SFNServiceException {
    name = "ResourceNotFound";
    $fault = "client";
    resourceName;
    constructor(opts) {
        super({
            name: "ResourceNotFound",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, ResourceNotFound.prototype);
        this.resourceName = opts.resourceName;
    }
}
exports.ResourceNotFound = ResourceNotFound;
class ServiceQuotaExceededException extends SFNServiceException_1.SFNServiceException {
    name = "ServiceQuotaExceededException";
    $fault = "client";
    constructor(opts) {
        super({
            name: "ServiceQuotaExceededException",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, ServiceQuotaExceededException.prototype);
    }
}
exports.ServiceQuotaExceededException = ServiceQuotaExceededException;
class ExecutionDoesNotExist extends SFNServiceException_1.SFNServiceException {
    name = "ExecutionDoesNotExist";
    $fault = "client";
    constructor(opts) {
        super({
            name: "ExecutionDoesNotExist",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, ExecutionDoesNotExist.prototype);
    }
}
exports.ExecutionDoesNotExist = ExecutionDoesNotExist;
class KmsInvalidStateException extends SFNServiceException_1.SFNServiceException {
    name = "KmsInvalidStateException";
    $fault = "client";
    kmsKeyState;
    constructor(opts) {
        super({
            name: "KmsInvalidStateException",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, KmsInvalidStateException.prototype);
        this.kmsKeyState = opts.kmsKeyState;
    }
}
exports.KmsInvalidStateException = KmsInvalidStateException;
class StateMachineDoesNotExist extends SFNServiceException_1.SFNServiceException {
    name = "StateMachineDoesNotExist";
    $fault = "client";
    constructor(opts) {
        super({
            name: "StateMachineDoesNotExist",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, StateMachineDoesNotExist.prototype);
    }
}
exports.StateMachineDoesNotExist = StateMachineDoesNotExist;
class InvalidToken extends SFNServiceException_1.SFNServiceException {
    name = "InvalidToken";
    $fault = "client";
    constructor(opts) {
        super({
            name: "InvalidToken",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, InvalidToken.prototype);
    }
}
exports.InvalidToken = InvalidToken;
class ExecutionLimitExceeded extends SFNServiceException_1.SFNServiceException {
    name = "ExecutionLimitExceeded";
    $fault = "client";
    constructor(opts) {
        super({
            name: "ExecutionLimitExceeded",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, ExecutionLimitExceeded.prototype);
    }
}
exports.ExecutionLimitExceeded = ExecutionLimitExceeded;
class ExecutionNotRedrivable extends SFNServiceException_1.SFNServiceException {
    name = "ExecutionNotRedrivable";
    $fault = "client";
    constructor(opts) {
        super({
            name: "ExecutionNotRedrivable",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, ExecutionNotRedrivable.prototype);
    }
}
exports.ExecutionNotRedrivable = ExecutionNotRedrivable;
class TaskDoesNotExist extends SFNServiceException_1.SFNServiceException {
    name = "TaskDoesNotExist";
    $fault = "client";
    constructor(opts) {
        super({
            name: "TaskDoesNotExist",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, TaskDoesNotExist.prototype);
    }
}
exports.TaskDoesNotExist = TaskDoesNotExist;
class TaskTimedOut extends SFNServiceException_1.SFNServiceException {
    name = "TaskTimedOut";
    $fault = "client";
    constructor(opts) {
        super({
            name: "TaskTimedOut",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, TaskTimedOut.prototype);
    }
}
exports.TaskTimedOut = TaskTimedOut;
class InvalidOutput extends SFNServiceException_1.SFNServiceException {
    name = "InvalidOutput";
    $fault = "client";
    constructor(opts) {
        super({
            name: "InvalidOutput",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, InvalidOutput.prototype);
    }
}
exports.InvalidOutput = InvalidOutput;
class ExecutionAlreadyExists extends SFNServiceException_1.SFNServiceException {
    name = "ExecutionAlreadyExists";
    $fault = "client";
    constructor(opts) {
        super({
            name: "ExecutionAlreadyExists",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, ExecutionAlreadyExists.prototype);
    }
}
exports.ExecutionAlreadyExists = ExecutionAlreadyExists;
class InvalidExecutionInput extends SFNServiceException_1.SFNServiceException {
    name = "InvalidExecutionInput";
    $fault = "client";
    constructor(opts) {
        super({
            name: "InvalidExecutionInput",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, InvalidExecutionInput.prototype);
    }
}
exports.InvalidExecutionInput = InvalidExecutionInput;
class MissingRequiredParameter extends SFNServiceException_1.SFNServiceException {
    name = "MissingRequiredParameter";
    $fault = "client";
    constructor(opts) {
        super({
            name: "MissingRequiredParameter",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, MissingRequiredParameter.prototype);
    }
}
exports.MissingRequiredParameter = MissingRequiredParameter;
